import { useTranslation } from 'react-i18next';
import { Box, SxProps } from '@mui/material';

import { Chip, IChipProps } from 'common/components/Chip';
import { receivedCertificateEndDateNear } from 'common/utils/receivedCertificate';
import { Tooltip } from 'common/components/Tooltip';
import { withSxProp } from 'common/utils/props';

interface IProps {
    endDate?: string;
    startDate?: string;
    sx?: SxProps;
    onClick?(): void;
}

export const ReceivedCertificateProgressChip = ({
    endDate,
    startDate,
    sx,
    onClick,
}: IProps) => {
    const [translate] = useTranslation();

    const isExpired = !endDate ? false : new Date(endDate) < new Date();
    const isEndDateNear = !!endDate && receivedCertificateEndDateNear(endDate);

    let color: IChipProps['color'] = 'success';
    let style: IChipProps['sx'] = {};
    let toolTipTitle = translate('receivedCertificateProgressChip.valid');

    if (isExpired) {
        color = 'error';
        toolTipTitle = translate('receivedCertificateProgressChip.expired');
    } else if (startDate && new Date(startDate) > new Date()) {
        color = 'success';
        toolTipTitle = translate('receivedCertificateProgressChip.notYetValid');
        style = { opacity: 0.3 };
    } else if (isEndDateNear) {
        color = 'warning';
        toolTipTitle = translate('receivedCertificateProgressChip.nearExpiry');
    }

    return (
        <Tooltip title={toolTipTitle}>
            <Box>
                <Chip
                    color={color}
                    sx={[...withSxProp(sx), style]}
                    onClick={onClick}
                />
            </Box>
        </Tooltip>
    );
};
